import React, { useRef, useEffect } from 'react';
import {useTheme} from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import PropTypes from 'prop-types';
import {withStyles, makeStyles } from '@material-ui/core/styles';
import {isLogin,getPrivileges} from '../../functions/Auth';
import { NavLink, useHistory } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ReactEcharts from 'echarts-for-react';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import HomeIcon from '@material-ui/icons/Home';

import { loadModules } from 'esri-loader';
import '../../scss/components/_panel_details.scss';
import '../../scss/components/_intersectionDetails.scss';
import Cookies from 'js-cookie';


import {getIntersectionTurningMovement,getIntersectionTruckPercentage,getIntersectionPedestrianMovement,getIntersectionBicycleMovement, getIntersectionBicycleCrosswalkMovement, getIntersectionLaneGeometryMovement} from '../../components_v2/Information/IntersectionGetData';
import FileList from '../StationDetails/FileList';
import DetailsOptions from '../StationDetails/DetailsOptions';
import NoDetails from '../StationDetails/NoDetails';
import StationCard from '../StationDetails/Intersection/StationCard';
import DetailsCard from '../StationDetails/Intersection/DetailsCard';
import SignalPlanningCard from '../StationDetails/Intersection/SignalPlanningCard';
import Turning from '../StationDetails/Intersection/Turning';
import Trunk from '../StationDetails/Intersection/Trunk';
import Pedestrian from '../StationDetails/Intersection/Pedestrian';
import Cycle from '../StationDetails/Intersection/Cycle';
import LaneGeometryPreview from '../StationDetails/Intersection/LaneGeometry';
import DataVehicles from '../StationDetails/Intersection/DataVehicles';

import API_PATH from "../../constants/config.json";
import PublicFilesCard from '../StationDetails/PublicFilesCard';
import SignalPlanning from '../StationDetails/SignalPlanning/SignalPlanning';
import CreateScenario from '../StationDetails/SignalPlanning/CreateScenario';
import DeleteScenario from '../StationDetails/SignalPlanning/DeleteScenario';
import LaneGeometry from '../DataManagement/LaneGeometry';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({
    
}));
const StyledTableRow = withStyles((theme) => ({
  
}))(TableRow);
//End Css code ...

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

let _selectedDate;
//Start Intersection component code ...
const Intersection = props => {
    const classes = useStyles();
    const mapRef = useRef();  
    const theme = useTheme();

    const [readOnlyOpt, setReadOnlyOpt] = React.useState(true)
    
    const { checkExportValue } = props;

    const turningCountDate = (props.data && props.data.intersentionRecentYear.hasOwnProperty('turningyear'))?props.data.intersentionRecentYear.turningyear:null;
    const pedestrianCountDate = (props.data && props.data.intersentionRecentYear.hasOwnProperty('pedestrianyear'))?props.data.intersentionRecentYear.pedestrianyear:null;
    const biCycleCountDate = (props.data && props.data.intersentionRecentYear.hasOwnProperty('bicycleyear'))?props.data.intersentionRecentYear.bicycleyear:null;

    const peakDate = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('peakDate'))?props.data.intersectionDatePeakData.peakDate:[];
    const dateVal = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('dateVal'))?props.data.intersectionDatePeakData.dateVal:null;
    const peakData = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('peakData'))?props.data.intersectionDatePeakData.peakData:null;
    
    const _amHasData = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('AmHasData'))?props.data.intersectionDatePeakData.AmHasData:[];
    const _midHasData = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('MidHasData'))?props.data.intersectionDatePeakData.MidHasData:[];
    const _pmHasData = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('PmHasData'))?props.data.intersectionDatePeakData.PmHasData:[];

    let _turningCountData = props.data.intersectionTurningMovement;
    let _truckCountData = props.data.intersectionTruckPercentage;
    let _pedestrianData = props.data.intersectionPedestrianMovement;
    let _bicycleCountData = props.data.intersectionBicycleMovement;
    let _bicycleCrosswalkCountData = props.data.intersectionBicycleCrosswalkMovement;
    let _laneGeometryData = props.data.intersectionLaneGeometryMovement;

    let approaches = {sb_approach: (props.stationData.sb_approach !== undefined) ? props.stationData.sb_approach : "", 
                      wb_approach: (props.stationData.wb_approach !== undefined) ? props.stationData.wb_approach : "", 
                      nb_approach: (props.stationData.nb_approach !== undefined) ? props.stationData.nb_approach : "", 
                      eb_approach: (props.stationData.eb_approach !== undefined) ? props.stationData.eb_approach : "",}
        
    let turingImgSrc = require("./../../assets/images/turning.svg");   
    let trackImage = require("./../../assets/images/truck.svg");
    let bicycleImage = require("./../../assets/images/cycle.svg");
    let pedestrianImage = require("./../../assets/images/Walk.svg"); 
    let laneGeometryImage = require("./../../assets/images/lane_geometry.svg"); 
    const [intersectionImagesTurnig, setIntersectionImagesTurnig] = React.useState(turingImgSrc);      
    const [amHasData, setAmHasData] = React.useState(null);
    const [midHasData, setMidHasData] = React.useState(null);
    const [pmHasData, setPmHasData] = React.useState(null);
    
    const [getValueDrop, setValueDrop] = React.useState(0);  
    const [selectedDate, setSelectedDate] = React.useState(null);    
    const [AMdata, setAMdata] = React.useState(null);
    const [MIDdata, setMIDdata] = React.useState(null);
    const [PMdata, setPMdata] = React.useState(null);
    const [timePeriod, setTimePeriod] = React.useState(null);

    const [movementData, setMovementData] = React.useState(null);  
    const [turningCountData, setTurningCountData] = React.useState(_turningCountData);
    const [truckCountData, setTruckCountData] = React.useState(_truckCountData);
    const [pedestrianData, setPedestrianData] = React.useState(_pedestrianData);
    const [bicycleCountData, setBicycleCountData] = React.useState(_bicycleCountData);
    const [bicycleCrosswalkCountData, setBicycleCrosswalkCountData] = React.useState(_bicycleCrosswalkCountData);
    const [laneGeometryData, setLaneGeometryData] = React.useState(_laneGeometryData);
    const [zoom, setZoom] = React.useState(null);

    const [scrolled, setScrolled] = React.useState(false);
    const panelRef = useRef();

    const [openAllDetails, setOpenAllDetails] = React.useState(false);    
    const handleCloseAllDetails = () => setOpenAllDetails(false);

    const [tabValue, setTabValue] = React.useState(0);
    const handleChangeTab = (event, newValue) => {
      if(newValue == 0){
        loadMap();
      }
      setTabValue(newValue);
      if(newValue === 2) {
        setReloadScenarios(true);
      }
    };

    const [stationList, setStationList] = React.useState([]);    
    const [totalItems, setTotalItems] = React.useState(0);
    const [userAccess, setUserAccess] = React.useState(true);    
    const [getLoader, setLoaderDisable] = React.useState(false);
    let enteriesPerPage = 50;

    const [myOptions, setmyOptions] = React.useState({})    
    const [getResponseData, setResponseData] = React.useState({})
    const [getResponseApproches, setResponseApproches] = React.useState([]);
    const [getDashedArray, setDashedArray] = React.useState([]);
    const [startPeakHour, setStartPeakHour] = React.useState(null);
    const [endPeakHour, setEndPeakHour] = React.useState(null);
    const [startPeakMin, setStartPeakMin] = React.useState(null);
    const [endPeakMin, setEndPeakMin] = React.useState(null);
    let flagPeakH=true;
    let flagPeakM=true;
    const [shadowHeader, setShadowHeader] = React.useState(false);
    const [showLoader,setShowLoader]=React.useState(false)

    const [showNewScenario,setShowNewScenario]=React.useState(false)
    const [reloadScenarios,setReloadScenarios]=React.useState(true);
    const [showDeleteScenario,setShowDeleteScenario]=React.useState(false);
    const [newScenarioId, setNewScenarioId] = React.useState(null);
    const [scenarioToDelete, setScenarioToDelete] = React.useState(null);
    const [showLaneConfig, setShowLaneConfig] = React.useState(false);

    const [activeFromCard, setActiveFromCard] = React.useState(null);
    const [changeTimePeriod, setChangeTimePeriod] = React.useState(false);
    
    useEffect(()=>{
      if (changeTimePeriod){
        if (AMdata !== null && MIDdata !== null && PMdata !== null){
          //onDateChange(Object.create({target : {value: _selectedDate}}));
          //onTimePeriorodChange(Object.create({target : {value: timePeriod}}));
          onDateChangeFromDataPointLayer(_selectedDate, timePeriod);
        }        
        setChangeTimePeriod(false);
      }
    },[changeTimePeriod]);
          
    useEffect(
      () => {        
      if(props.data){  
        setNewScenarioId(null);
        let startPeak = null;
        //if(!AMdata){
          setAMdata((props.data && props.data.intersectionDatePeakData.hasOwnProperty('AMdata'))?props.data.intersectionDatePeakData.AMdata:null);          
          
          if(startPeak == null){
            setStartPeakHour((props.data && props.data.intersectionDatePeakData.hasOwnProperty('AMdata') && props.data.intersectionDatePeakData.AMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.AMdata.hour.startdate:null);
            setEndPeakHour(((props.data && props.data.intersectionDatePeakData.hasOwnProperty('AMdata') && props.data.intersectionDatePeakData.AMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.AMdata.hour.enddate:null));          
            setStartPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('AMdata') && props.data.intersectionDatePeakData.AMdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.AMdata.minute.startdate:null);
            setEndPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('AMdata') && props.data.intersectionDatePeakData.AMdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.AMdata.minute.enddate:null);
            startPeak = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('AMdata') && props.data.intersectionDatePeakData.AMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.AMdata.hour.startdate:null;
          }          
        //}
        //if(!MIDdata){
          setMIDdata((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata'))?props.data.intersectionDatePeakData.MIDdata:null);
          
          if(startPeak == null){
            setStartPeakHour((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.MIDdata.hour.startdate:null);
            setEndPeakHour(((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.MIDdata.hour.enddate:null));
            setStartPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.MIDdata.minute.startdate:null);
            setEndPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.MIDdata.minute.enddate:null);
            startPeak = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.MIDdata.hour.startdate:null;
          }
        //}
        //if(!PMdata){
          setPMdata((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata'))?props.data.intersectionDatePeakData.PMdata:null); 
          
          if(startPeak == null){
            setStartPeakHour((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.PMdata.hour.startdate:null);
            setEndPeakHour(((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.PMdata.hour.enddate:null));
            setStartPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.PMdata.minute.startdate:null);
            setEndPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.PMdata.minute.enddate:null);
            startPeak = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.PMdata.hour.startdate:null;
          }
        //}
        //if(!timePeriod){
          const getDateByCapacityPeriod=(period)=>{
            for (const [key, value] of Object.entries(props.data.intersectionDatePeakData.peakData)){
              if (value.hasOwnProperty(period))
                if (value[period]["count"] > 0){
                  return value.date;
                }
            }
          }
          if (props.toggleMarkerBasedOnCapacityLayer === true){
            let _tempSelectedDate = false;
            if (props.data.intersectionDatePeakData.hasOwnProperty('peakData'))
              _tempSelectedDate = getDateByCapacityPeriod(props.toggleMarkerCapacitySelected.toLowerCase());
            if (_tempSelectedDate){
              _selectedDate = _tempSelectedDate;
              setSelectedDate(_selectedDate);
              setTimePeriod(props.toggleMarkerCapacitySelected);
            }else{
              _selectedDate = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('selectedDate'))?props.data.intersectionDatePeakData.selectedDate:null;
              setSelectedDate(_selectedDate);
              setTimePeriod(props.data && props.data.intersectionDatePeakData.hasOwnProperty('timePeriod')?props.data.intersectionDatePeakData.timePeriod:null);
            }
        } else {
          _selectedDate = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('selectedDate'))?props.data.intersectionDatePeakData.selectedDate:null;
          setSelectedDate(_selectedDate);
          setTimePeriod(props.data && props.data.intersectionDatePeakData.hasOwnProperty('timePeriod')?props.data.intersectionDatePeakData.timePeriod:null);
        }
          //setTimePeriod((props.data && props.data.intersectionDatePeakData.hasOwnProperty('timePeriod'))?_timePeriod:null);//props.data.intersectionDatePeakData.timePeriod
        //}             
        //if(!movementData){          
          setTurningCountData(_turningCountData);
          setTruckCountData(_truckCountData);
          setPedestrianData(_pedestrianData);
          setBicycleCountData(_bicycleCountData);       
          setBicycleCrosswalkCountData(_bicycleCrosswalkCountData)          ;
          setLaneGeometryData(_laneGeometryData);              
        //}      
        // time period validation 
        if(props.data && props.data.intersectionDatePeakData.hasOwnProperty('timePeriod')) {
          let timep = props.data.intersectionDatePeakData.timePeriod;
          if(timep === "PM" ) {
            setStartPeakHour((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.PMdata.hour.startdate:null);
            setEndPeakHour(((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.PMdata.hour.enddate:null));
            setStartPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.PMdata.minute.startdate:null);
            setEndPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.PMdata.minute.enddate:null);
            startPeak = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('PMdata') && props.data.intersectionDatePeakData.PMdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.PMdata.hour.startdate:null;
          } else if (timep === "MID") {
            setStartPeakHour((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.MIDdata.hour.startdate:null);
            setEndPeakHour(((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.MIDdata.hour.enddate:null));
            setStartPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.MIDdata.minute.startdate:null);
            setEndPeakMin((props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('minute'))?props.data.intersectionDatePeakData.MIDdata.minute.enddate:null);
            startPeak = (props.data && props.data.intersectionDatePeakData.hasOwnProperty('MIDdata') && props.data.intersectionDatePeakData.MIDdata.hasOwnProperty('hour'))?props.data.intersectionDatePeakData.MIDdata.hour.startdate:null;
          }
        }
        if (props.toggleMarkerBasedOnCapacityLayer === true)
          setChangeTimePeriod(true);
      }            
  }, [props.searchPanel, props.stationData, props.data]);   
  useEffect(
    () => { 
      if( truckCountData){
        setShowLoader(false)
      }
      
           }, [turningCountData,truckCountData])    
    
    const handleOpenAllDetailsSignalPlanning = () => {
      setReloadScenarios(true);
      setTabValue(2);
      setOpenAllDetails(true);
      loadMap();
      getFileList();
      //review time has data             
      if(props.hasData){        
        getIntersectionTrafficData(getCurrentDataTime());
      }
    }; 
    const handleOpenAllDetails = () => {
      setTabValue(0);
      setOpenAllDetails(true);
      loadMap();
      getFileList();
      //review time has data             
      if(props.hasData){        
        getIntersectionTrafficData(getCurrentDataTime());
      }      
    }; 
    const getCurrentDataTime = () =>{
      let dataPeriod = null;
        let dataTime = null;
        if(!dataPeriod && AMdata.count && timePeriod == 'AM'){
          dataPeriod = 'AM';    
          dataTime =  AMdata;
        }
        if(!dataPeriod && MIDdata.count && timePeriod == 'MID'){
          dataPeriod = 'MID';    
          dataTime =  MIDdata;
        }
        if(!dataPeriod && PMdata.count && timePeriod == 'PM'){
          dataPeriod = 'PM';    
          dataTime =  PMdata;
        } 

        return dataTime;
    } 
    const onDateChangeFromDataPointLayer = (date, period) => {
      let dataTime = null;
      for (const [key, value] of Object.entries(peakData)){
        if (value.date == date){
          if (value.am){
            setAMdata(value.am);     
            setAmHasData((value.am.count == 0) ? true : false);  
          }
          if (value.mid){
            setMIDdata(value.mid);     
            setMidHasData((value.mid.count == 0) ? true : false);  
          }
          if (value.pm){
            setPMdata(value.pm);     
            setPmHasData((value.pm.count == 0) ? true : false);  
          }          
          if (value[period.toLowerCase()]["count"] > 0){
            dataTime = value[period.toLowerCase()];
          }
        }          
      }
        reviewTimePeriod(period,dataTime);
    };
    const onDateChange = (e) => {          
        setSelectedDate(e.target.value);
        let dataPeriod = null;
        let dataTime = null;
        peakData && peakData.length > 0 && peakData.map((val) => {
          if (val.date == e.target.value) {            
            if (val.am) {
              setAMdata(val.am);     
              setAmHasData((val.am.count == 0)?true : false);          
            }
            if (val.mid) {
              setMIDdata(val.mid);
              setMidHasData((val.mid.count == 0)?true : false);
            }
            if (val.pm) {
              setPMdata(val.pm);
              setPmHasData((val.pm.count == 0)?true : false);
            }
            
            if(!dataPeriod && val.am.count){
              dataPeriod = 'AM';    
              dataTime =  val.am;              
            }
            if(!dataPeriod && val.mid.count){
              dataPeriod = 'MID';   
              dataTime =  val.mid;         
            }
            if(!dataPeriod && val.pm.count){
              dataPeriod = 'PM';    
              dataTime =  val.pm;        
            }
            setTimePeriod(dataPeriod);            
          }
        })             
        reviewTimePeriod(dataPeriod,dataTime);               
      }
      const onTimePeriorodChange = (e) =>{          
          setTimePeriod(e.target.value);
          reviewTimePeriod(e.target.value);           
      }
      const reviewTimePeriod = (value,dataTime=null) =>{
        //set new data to diagram
        let data = null;
        if(value == "AM"){
          data = (dataTime != null)?dataTime:AMdata;
        }
        if(value == "MID"){
          data = (dataTime != null)?dataTime:MIDdata;
        }
        if(value == "PM"){
          data = (dataTime != null)?dataTime:PMdata;
        }       
        setStartPeakHour(data.hour.startdate);
        setEndPeakHour(data.hour.enddate);          
        setStartPeakMin(data.minute.startdate);
        setEndPeakMin(data.minute.enddate); 
        updateMovementData(data);
        getIntersectionTrafficData(data);         
      }

      const updateMovementData = async (data) => {
        setShowLoader(true)
        setMovementData(true);
        setTurningCountData(await getIntersectionTurningMovement(data,props.stationData.station_id));
        setTruckCountData(await getIntersectionTruckPercentage(data,props.stationData.station_id));
        setPedestrianData(await getIntersectionPedestrianMovement(data,props.stationData.station_id));
        setBicycleCountData(await getIntersectionBicycleMovement(data,props.stationData.station_id));
        setBicycleCrosswalkCountData(await getIntersectionBicycleCrosswalkMovement(data,props.stationData.station_id));
      }
      const changeImages = e => {
        e.preventDefault();
        let checkValue = e.target.value;
        setValueDrop(checkValue)
        //props.onChangeMethod(checkValue)
        setImage(checkValue);
      }
      const setImage = img => {
        let imgScr = [turingImgSrc,trackImage,pedestrianImage,bicycleImage,laneGeometryImage];
        setIntersectionImagesTurnig(imgScr[img])
      }         
      //This method is use for map .... start
  const loadMap = () => {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search"], { css: true })
      .then(async ([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search]) => {        
        const map = new ArcGISMap({
          basemap: (sessionStorage.getItem('baseMapType') !=null && sessionStorage.getItem('baseMapType') =='hybrid')?'hybrid':'streets-navigation-vector',
          slider: false
        });        
        let view = new MapView({
          container: mapRef.current,
          map: map,
          ui: {
            components: ['home', 'locate'] // specify only the components you want
          },
        });
        let zoom = new Zoom({
          view: view,
        });
        let featureLayer = new FeatureLayer({
          url: sessionStorage.getItem('mapURL')
        });
        featureLayer.when(function () { // adds feature layer to map view
          let vp = new Viewpoint({
            targetGeometry: featureLayer.fullExtent
          });
          view.extent = featureLayer.fullExtent;

        });
        setZoom(zoom);
        map.add(featureLayer);
        //let position = await getStationDetails();
        featureLayer.when(async function () { // adds feature layer to map view         
          // console.log('Logn :'+longitude+ 'Lat :'+latitude);          
          let point = new Point(props.stationData.longitude, props.stationData.latitude);          
          let pointSymbol = {
            type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
            url: (props.sharedStation)?require("../../assets/icons/marker_Intersection_shared.png"):require("../../assets/icons/marker_Intersection.png"),
            width: "34px",
            height: "34px",
            yoffset: "20px"
          }
          let pointGraphic = new Graphic(point, pointSymbol);
          view.graphics.add(pointGraphic);
          view.goTo(pointGraphic).then(function () {
            view.zoom = view.zoom + 5;            
            if(!props.hasData){
              //view.graphics.remove(pointGraphic);
            }
          });
        });

      });
    }
    const getFileList = () => { // API call to get all files
      setLoaderDisable(true);
      try {
        axios({
          method: 'post',
          data: {
            stationId: props.stationData.station_id,
            pageNo: 1,
            entriesPerPage: enteriesPerPage
          },
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.fileList,
        })
          .then(async function (response) {            
            if (response.status && response.status == '200') {
              setLoaderDisable(false);
              setStationList(response.data.data.rows);
              setTotalItems(response.data.data.count);
            } else {
              setStationList([]);
              setLoaderDisable(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.data.status == 403) {
                setUserAccess(false);
                setLoaderDisable(false);
                setStationList([]);
              } else {
                setStationList([]);
                setLoaderDisable(false);
              }
            } else {
              setStationList([]);
              setLoaderDisable(false);
            }
          })
      } catch (error) {
        console.error(error);
        setLoaderDisable(false);
      }
    }
    //This Method is use for get intersection traffic data .... Start
    const getIntersectionTrafficData = async(time) => {
      try {
       await axios({
          method: 'post',
          url: API_URL + API_PATH.getIntersectionTrafficData,
          data: {
            stationId: props.stationData.station_id,
            startdate: time.startdate,
            enddate: time.enddate
          },
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
        }).then(function (response) {
          if (response && (response.data.data && response.data.approaches)) {
            setResponseData(response.data.data);
            setResponseApproches(response.data.approaches);            
            let northGraph = [];
            let southGraph = [];
            let eastGraph = [];
            let westGraph = [];
            let dateTimeArray = [];
            let dashedArray = [];
  
            response.data.data.map((ele, index) => {
              dateTimeArray.push(ele.starttime)
              northGraph.push(ele.north.sum);
              southGraph.push(ele.south.sum);
              eastGraph.push(ele.east.sum);
              westGraph.push(ele.west.sum);
              dashedArray.push(checkCondition(ele.north, ele.east, ele.west, ele.south))
            })
  
  
            setDashedArray(dashedArray);
            myOptionFunction(northGraph, southGraph, eastGraph, westGraph, dateTimeArray);
  
          } else {
            setResponseData({});          
          }
        }).catch((err) => {       
          setResponseData({});
        })
  
      }
      catch (error) {
        setResponseData({});      
      }
    }
    const checkCondition = (north, east, west, south) => {
      let checkArray = [];
      Object.values(north).map((obj, index) => {
        checkArray.push(obj);
      })
      Object.values(east).map((obj, index) => {
        checkArray.push(obj);
      })
      Object.values(west).map((obj, index) => {
        checkArray.push(obj);
      })
      Object.values(south).map((obj, index) => {
        checkArray.push(obj);
      })
      return checkArray.includes("--");
    }
    function myOptionFunction(northGraph, southGraph, eastGraph, westGraph, dateTimeArray) {
      let rotateVal = dateTimeArray.length >= 24 ? 45 : 0;
      setmyOptions({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            show: false,
            type: 'none'
          },
          textStyle: {
            fontSize: 10,
          }
        },
        title: {
          text: 'Entering Volumes',
          bottom: '20px',
          left: '45%',
          textStyle: {
            fontSize: 12,
            fontFamily: 'Inter-Medium',
            fontStyle: 'normal',
            fontWeight: 500,            
            lineHeight: 16
          }
        },
        legend: {
          orient: 'horizontal',
          data: ['NB', 'SB', 'EB', 'WB'],
          bottom: '0px',
          textStyle: {
            fontSize: 10,
          }
        },
        grid: {
          bottom: '90px',
          height: 'auto',
          top: '20px',
          left: '40px',
          right: '15px',
        },
        xAxis: {         
          axisLabel: {
            rotate: rotateVal,
            fontSize: 10,
            interval: 0
          },
          type: 'category',
          data: dateTimeArray,
          splitLine: {
            show: true,
            lineStyle: {              
              color: '#F4F4F5',              
              width: 1
            }
          },
          axisLine : {
            show : false
          },
          axisTick : {
            show : false
          }
        },
        yAxis: {
          type: 'value',      
          splitLine: {
            show: true,
            lineStyle: {              
              color: '#F4F4F5',              
              width: 1
            }
          },
          axisLabel: {
            fontSize:  10,
          },
          axisLine : {
            show : false
          },
          axisTick : {
            show : false
          }
        },
        series: [
          {
            name: 'NB',
            type: 'bar',
            itemStyle: {
              color: "#3B82F6",              
              width:'35px'
            },         
            stack: 'five',
            label: {
              show: false,
              position: 'insideRight'
            },
            data: northGraph,
          },
          {
            name: 'SB',
            type: 'bar',
            itemStyle: {
              color: "#10B981",              
              width:'35px'
            },         
            stack: 'five',
            label: {
              show: false,
              position: 'insideRight'
            },
            data: southGraph,
          },
          {
            name: 'EB',
            type: 'bar',
            itemStyle: {
              color: "#F59E0B",             
              width:'35px'
            },         
            stack: 'five',
            label: {
              show: false,
              position: 'insideRight'
            },
            data: eastGraph,
          },
          {
            name: 'WB',
            type: 'bar',
            itemStyle: {
              color: "#F87171",              
              width:'35px'
            },         
            stack: 'five',
            label: {
              show: false,
              position: 'insideRight'
            },
            data: westGraph,
          },
        ]
      })
    }       
    const peakHSummComponent = () => {
      return(
        <>        
        <Grid item xs={8}>                
                <Select                  
                    className="select-dp slc-time-perido-details"                                     
                    value={(selectedDate)?selectedDate:_selectedDate}
                    height='38px'                               
                    style={{width:'248px'}}
                    onChange={(e) => onDateChange(e)}
                    IconComponent={ExpandMoreIcon}
                    MenuProps={{PaperProps:{className:'slct-details-cmp'}}}
                >
                    {peakDate.map((val, index) => {
                        return <MenuItem value={dateVal[index]}>{val}</MenuItem>                        
                    })
                    }                                    
                </Select>
        </Grid>
        <Grid item xs={4} style={{textAlign:'center',paddingLeft: '5px'}}>
                <Select             
                    className="select-dp"                       
                    value={timePeriod} 
                    onChange={(e) => onTimePeriorodChange(e)}
                    height='38px'   
                    style={{width:'120px'}}   
                    IconComponent={ExpandMoreIcon}   
                    MenuProps={{PaperProps:{className:'slct-details-cmp'}}}                     
                >
                <MenuItem value='AM' disabled={(amHasData != null)?amHasData:_amHasData}>AM</MenuItem>
                <MenuItem value='MID' disabled={(midHasData != null)?midHasData:_midHasData}>MID</MenuItem>                
                <MenuItem value='PM'disabled={(pmHasData != null)?pmHasData:_pmHasData}>PM</MenuItem>
                </Select>
          </Grid>
      </>    
      )
    } 
    const peakInfoDetailsComponent = () => {
      return (
        <Grid container className='info-count-pn'>
              <Grid item style={{minWidth:'109px'}}>
                <label className='title-peak-hour'>{timePeriod} Peak hour</label>
                <span className='time-peak-lb'>                
                {(timePeriod=='AM')?(AMdata.hasOwnProperty('hour'))?(AMdata.hour.startdate+' - '+AMdata.hour.enddate):null:null}
                {(timePeriod=='MID')?(MIDdata.hasOwnProperty('hour'))?(MIDdata.hour.startdate+' - '+MIDdata.hour.enddate):null:null}
                {(timePeriod=='PM')?(PMdata.hasOwnProperty('hour'))?(PMdata.hour.startdate+' - '+PMdata.hour.enddate):null:null}
                </span>    
              </Grid>
              <Grid item style={{minWidth:'109px',paddingLeft:'32px'}}>
                <label className='title-peak-hour'>{timePeriod} Peak 15 min</label>   
                <span className='time-peak-lb'>             
                {(timePeriod=='AM')?(AMdata.hasOwnProperty('minute'))?(AMdata.minute.startdate+' - '+AMdata.minute.enddate):null:null}
                {(timePeriod=='MID')?(MIDdata.hasOwnProperty('minute'))?(MIDdata.minute.startdate+' - '+MIDdata.minute.enddate):null:null}
                {(timePeriod=='PM')?(PMdata.hasOwnProperty('minute'))?(PMdata.minute.startdate+' - '+PMdata.minute.enddate):null:null}
                </span>   
              </Grid>
        </Grid>
      )
    } 
    const setExportData = () => {
      if(props.hasData) {
        props.groupStations(props.stationData.station_id, props.stationData.station_type, props.stationData.client_station_id, props.stationData.station_location);
        props.checkExportValue();
      }
    }
    const handleScroll = () => {
      if (panelRef.current) {
        const { scrollTop } = panelRef.current;
        if (scrollTop > 0) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      }
  };
  const homeEvent = () => { // event to go at initial view
    
  }
  const ZoomInEvent = () => { // event to zoom in map
    zoom.zoomIn();

  }
  const zoomOutEvent = () => { // event to zoom out map
    zoom.zoomOut();
  }
  const scrollHandle = (scroll) =>{    
    if(scroll.target.scrollTop>0){
      setShadowHeader(true);
    }else{
      setShadowHeader(false);
    }    
  }

  const handleDeleteScenario = () => {
    let id = scenarioToDelete ? scenarioToDelete['scenario_id'] : null;
    if(id) {
      try {
        axios({
            method: 'delete',
            headers: {
              'payload': Cookies.get('payload'),
            },
            url: API_URL + API_PATH.deleteScenario+id,
        })
        .then(async function (response) {
                if (response && response.status == '200') {
                  setReloadScenarios(true);
                  setShowDeleteScenario(false);
                } 
            })
            .catch((err) => {
                console.error(err);        
            })
      } catch (error) {
          console.error(error);
      }
    }
  }


    return (
        <React.Fragment>
            {(getPrivileges().length !== 0)?<div className='btn-menu-details' style={{marginTop:'-45px',marginRight:'10px'}}>
                <DetailsOptions 
                modal={handleOpenAllDetails}
                checkExportValue={checkExportValue}
                setExportData={setExportData}
                hasData={props.hasData}
                stationData={props.stationData}                
                handleStationDetails={props.handleStationDetails}
                />      
            </div>:null}
            {props.stationData.public_download_allowed && getPrivileges().length === 0 ?<div className='btn-menu-details' style={{marginTop:'-45px',marginRight:'10px'}}>
                <DetailsOptions 
                isOnlyExport={true}
                modal={handleOpenAllDetails}
                checkExportValue={checkExportValue}
                setExportData={setExportData}
                hasData={props.hasData}
                stationData={props.stationData}                
                handleStationDetails={props.handleStationDetails}
                />      
            </div> : null}
            <div className="station-details-main">
              <div className={'results-title-lbl'}> 
                <label className='station-list-lbl'>Intersection summary</label>
              </div>
            <div className={scrolled? 'station-details-info scrolled-el' :'station-details-info'} >            
            <div className='panel-info-data'  onScroll={handleScroll} ref={panelRef}>           
              <StationCard clss={!props.hasData?'details-main-info details-main-no-data':'details-main-info'} fixed={true} sharedStation={props.sharedStation} sharedAgencyName={props.sharedAgencyName} stationData={props.stationData} turningCountDate={turningCountDate} pedestrianCountDate={pedestrianCountDate} biCycleCountDate={biCycleCountDate}/>
            {(props.loadingDetails)?null:<>{(!props.hasData) ? 
              <div className='panel-info-data-wrap-no-data'>
                <NoDetails handleOpenAllDetails={handleOpenAllDetails} showButton={true} stationData={props.stationData} />
              </div>
            :<div className='panel-info-data-wrap'>
            {props.sharedStation?<Card className='tb-details-info tb-shared-info' style={{marginBottom:'15px'}}> 
              <img src={require('./../../assets/icons/shared_icon.svg')}/>
              <div className="tb-shared-info-lb">
                  <span>Shared</span>
                  <label title={props.sharedAgencyName}>This station is shared from {props.sharedAgencyName}</label>
              </div> 
            </Card>:null}
            <Grid container className='peak-panel-opt'>
              <Grid item xs={12}>
                  <label className='info-sub-title'>Peak hour summary</label> 
              </Grid>
              {peakHSummComponent()}
            </Grid>
            <Card className='tb-details-info' style={{marginBottom:'15px',marginTop:'8px'}}>                             
              {peakInfoDetailsComponent()}              
              <FormControl className='diagrams-opt-list-pn'>
                <label className='lb-opt-list' id="demo2-simple-select-label">Data type</label>
                <Select    
                  className="select-dp"    
                  style={{width:'100%'}}          
                  labelId="demo2-simple-select-label"
                  id="demo2-simple-select"
                  value={getValueDrop}
                  label="Data type"    
                  onChange={(e) => { changeImages(e) }}    
                  IconComponent={ExpandMoreIcon}  
                  MenuProps={{PaperProps:{className:'slct-details-data-type'}}}        
                >                  
                    <MenuItem className="item-movements-sl" value={0}>Hourly Turning Movements <CheckIcon style={{display:'none'}} /></MenuItem>
                    <MenuItem className="item-movements-sl" value={1}>Truck Percentages <CheckIcon style={{display:'none'}} /></MenuItem>
                    <MenuItem className="item-movements-sl" value={2}>Pedestrian Volumes <CheckIcon style={{display:'none'}} /></MenuItem>
                    <MenuItem className="item-movements-sl" value={3}>Bicycle Movements <CheckIcon style={{display:'none'}} /></MenuItem>                                    
                </Select>
              </FormControl>              
              <div className='intersection-counts-pn' style={{textAlign:'center', "margin-top": "1rem"}}>
                <div className='sb-approach' style={{marginBottom: '-10px'}}>
                  <span>{approaches.sb_approach}</span>
                </div>                      
                <div style={{/* marginTop:'10px', */width:'300px',position:'relative',left:'50%',marginLeft:'-150px', display: "flex", "flex-direction": "column"}}>
                  <img src={intersectionImagesTurnig} style={{ width: "100%"}} />
                  {(getValueDrop==0)? <Turning turningCountData={turningCountData}/> : null}
                  {(getValueDrop==1)? <Trunk truckCountData={truckCountData}/> : null}
                  {(getValueDrop==2)? <Pedestrian pedestrianData={pedestrianData}/> : null}                    
                  {(getValueDrop==3)? <Cycle bicycleCountData={bicycleCountData} bicycleCrosswalkCountData={bicycleCrosswalkCountData} /> : null}
                  <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute"}}>
                    <div style={{display: 'flex', height: '50%', width: "50%", "align-items":"flex-start", "justify-content": "flex-start", transform:"rotate(270deg)"}}>
                      <div style={{width: "100%", position: "absolute", top: "-8px"}}>
                        <span>{approaches.eb_approach}</span>
                      </div>
                    </div>
                    <div style={{display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform:"rotate(90deg)"}}>
                      <div style={{width: "100%", position: "absolute", top: "-8px"}}>
                        <span>{approaches.wb_approach}</span>
                      </div>
                    </div>
                  </div>
                </div> 
                <div className='nb-approach' style={{marginTop: '-10px'}}>
                  <span>{approaches.nb_approach}</span>
                </div>
              </div>
            </Card> 
            {
              (getPrivileges().length !== 0 || props.stationData['FK_lane_config_id']) &&
              <>
              <label className='info-sub-title'>Lane geometry</label>            
              <LaneGeometryPreview laneGeometryData={laneGeometryData} stationData={props.stationData} setShowLaneConfig={setShowLaneConfig} setReadOnlyOpt={setReadOnlyOpt} approaches={approaches} />
              </>
            }
            {
              props.stationData.scenario?<>
                <label className='info-sub-title'>Capacity planning</label>
                <SignalPlanningCard 
                  station_id={props.stationData.station_id} 
                  scenario={props.stationData.scenario} 
                  date_count={props.stationData.scenario_date_count} 
                  period={props.stationData.scenario_period} 
                  critical_flow_ratio={props.stationData.scenario_critical_flow_ratio} 
                  handleOpenAllDetailsSignalPlanning={handleOpenAllDetailsSignalPlanning}
                  activeFromCard={activeFromCard}
                  setActiveFromCard={setActiveFromCard}
                  toggleMarkerCapacitySelected={props.toggleMarkerCapacitySelected}
                  toggleMarkerBasedOnCapacityLayer={props.toggleMarkerBasedOnCapacityLayer}
                  timePeriod={timePeriod}
                  />            
              </>:null
            }
            
            <label className='info-sub-title'>Details</label>            
            <DetailsCard stationData={props.stationData}/>
            {/*<label className='info-sub-title'>Description</label>
            <Card className='des-info-station' style={{paddingTop:'10px',minHeight:'50px'}}>
                {(props.stationData && props.stationData.description)?props.stationData.description:null}
            </Card>*/}       
            {
              props.stationData && props.stationData.miscellaneous ?
              <>
                <label className='info-sub-title'>Miscellaneous</label>
                <Card className='tb-details-miscellaneous'>
                  {props.stationData.miscellaneous}
                </Card>
              </>
              :null
            }    
            <PublicFilesCard stationData={props.stationData}/>
            {(getPrivileges().length !== 0)?<Grid container>
              <Grid item xs={12} style={{textAlign: 'center',paddingBottom:'5px'}}>
                <a className='btn-blue btn-view-all-details' onClick={handleOpenAllDetails}><span>View all details</span></a>
              </Grid>            
            </Grid>:null}
            </div>}</>}
            </div>
            </div>
            </div>  

           <Modal
            open={openAllDetails}
            onClose={() => setShowDeleteScenario(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description" 
            className={'z_index_test'}             
          >
           <div className='md-all-details' style={tabValue==0?{width:'1000px',height:'90%'}:{width:'1328px' /* width:'1264px' */ ,height:'90%'}}>
             <div className='md-header-details' style={shadowHeader?{boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)'}:{}}>
             <Tabs value={tabValue} onChange={handleChangeTab} className='tb-hd-main-opts' aria-label="basic tabs example">
              <Tab label="Station details" {...a11yProps(0)} />
              <Tab label="Traffic counts" {...a11yProps(1)} disabled={!props.hasData} /> 
              <Tab label="Capacity planning" {...a11yProps(2)} />              
            </Tabs> 
              <div className='header-options-md'>
                <Button 
                  className='btn-blue btn-export-data' 
                  variant="contained" 
                  disabled={!props.hasData}
                  style={!props.hasData?{opacity:'0.5'}:{}}
                  onClick={setExportData}><img src={require('../../assets/icons/File - Download.svg')} style={{marginRight:'10px'}}/> 
                  Export
                </Button>   
                <NavLink target="_blank" to={{ pathname: '/intersection_details?station='+props.stationData.client_station_id+(props.sharedStation?'&by='+props.stationData.FK_agency_id:''), state: { clicked: true } }} className='btn-full-screen'>
                  <img src={require("./../../assets/icons/full_screen.svg")} />
                </NavLink>
                <IconButton aria-label="delete" className='btn-close-md' onClick={handleCloseAllDetails}>
                  <img src={require("./../../assets/icons/close.svg")} />  
                </IconButton>                              
              </div>  
             </div>
             <div className='md-body-details' /* onScroll={(e) => scrollHandle(e)} */>     
             {props.sharedStation?<div className='tb-shared-info-mn'><Card className='tb-details-info tb-shared-info' style={{}}> 
                  <img src={require('./../../assets/icons/shared_icon.svg')}/>
                  <div className="tb-shared-info-lb">
                      <span>Shared</span>
                      <label>This station is shared from {props.sharedAgencyName}</label>
                  </div> 
                </Card></div>:null}
              <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={tabValue}
                        onChangeIndex={handleChangeTab}
              >         
              <TabPanel value={tabValue} index={0} dir={theme.direction}>  
                <div className='details-summary-map-files'>                
                  <div className='details-summary-map'>
                    <div className='details-summary'>
                      <div className='details-card'>
                        <label>Station</label>
                        <div className='md-body-card-details' style={{}}>
                          <StationCard clss={!props.hasData?'details-main-info details-main-no-data':'details-main-info'} sharedStation={props.sharedStation} sharedAgencyName={props.sharedAgencyName} stationData={props.stationData} turningCountDate={turningCountDate} pedestrianCountDate={pedestrianCountDate} biCycleCountDate={biCycleCountDate}/>
                        </div>
                      </div>                   
                      {(props.hasData)?<div className='details-card'>
                        <label>Details</label>   
                        <div style={{}}>                   
                          <DetailsCard stationData={props.stationData}/>                     
                        </div>
                      </div>:<NoDetails stationData={props.stationData}/>}  
                      {(props.hasData && props.stationData.miscellaneous)?
                        <div className='details-card' style={{marginTop: '16px', width: '376px'}}>
                          <label className='info-sub-title'>Miscellaneous</label>
                          <Card className='info-details-miscellaneous'>
                            {props.stationData.miscellaneous}
                          </Card>
                        </div>
                      :null}                 
                    </div>
                    <div className='details-map'>
                      <label>Map</label>  
                      {/*!props.hasData?<div className='disabled-map' style={{height: '90%'}}></div>:null*/}
                      <div ref={mapRef} className={!props.hasData?'map-details-pn map-details-no-data':'map-details-pn'} data-testid='mapView' style={!props.hasData?{opacity:'1'}:{}, props.hasData && props.stationData.miscellaneous ? {height: '444px'} : {}}></div>
                      <Box display='flex' flexDirection="column" className="homeIconList" style={!props.hasData?{opacity:'1'}:{}}>
                        {/* <div data-testid="homeBtn" className="homeIcon" title="Home">
                          <HomeIcon onClick={() => homeEvent()} title="Home" />
                        </div>                         */}
                        <div data-testid="zoomInBtn" className="zoomIcon" style={{ marginBottom: '-3px' }} title="Zoom In">
                          <AddIcon onClick={() => ZoomInEvent()} title="Zoom In" />
                        </div>
                        <div data-testid="zoomOutBtn" className="inIcon" title="Zoom Out">
                          <RemoveIcon onClick={() => zoomOutEvent()} title="Zoom Out" />
                        </div>
                      </Box>
                    </div>
                  </div>  
                  <div className='tb-list-files-act' style={{marginBottom:'16px'}}>
                      <Card className='card-file-list'>
                        <FileList list={stationList} getFileList={getFileList} fullscreen={false} stationData={props.stationData} sharedStation={props.sharedStation}/> 
                      </Card>
                  </div>
                </div>
              </TabPanel>
              <TabPanel value={tabValue} index={1} dir={theme.direction}>
                <div className='details-traffic-count'>
                  <div className='tc-card'>
                    <label>Station</label>
                    <div className='md-body-card-details'>
                      <StationCard sharedStation={props.sharedStation} sharedAgencyName={props.sharedAgencyName} stationData={props.stationData} turningCountDate={turningCountDate} pedestrianCountDate={pedestrianCountDate} biCycleCountDate={biCycleCountDate}/>
                    </div>
                  </div>  
                  <div className='tc-card' style={{margin:'0px 16px'}}>
                    <label>Count date & time</label>
                    <Card className='details-main-info details-date-time' style={{width:'100%'}}>
                        <Grid container>
                          <Grid item xs={12} className='opt-details-peak-hour'>
                            {peakHSummComponent()}
                          </Grid>
                        </Grid>
                    </Card>
                  </div>
                  <div className='tc-card'>
                    <label>Peak hours</label>
                    <Card className='details-main-info details-peak-hour-dt2' style={{width:'100%'}}>
                        <Grid container>
                          <Grid item xs={12}>
                            {peakInfoDetailsComponent()} 
                          </Grid>
                        </Grid>
                    </Card>
                  </div>
                </div>
                <div className='details-tf-study'>
                  <div className='details-tf-study-card' style={{marginRight:'16px'}}>
                    <label>Hourly turning movements</label>
                    <Card className='details-main-info-img'>
                      <div className='intersection-counts-pn' style={{textAlign:'center'}}>
                      {(showLoader)?<div className='loader-details-progress top-280'>
                        <div className={'loader'}></div>
                      </div>:null } 
                          <div className='sb-approach' style={{ margin: "15px 0px -10px 0px" }}>
                            <span>{approaches.sb_approach}</span>
                          </div>  
                        <div style={{width:'608px',height:'608px',position:'relative',left:'50%',marginLeft:'-304px',opacity: showLoader?'50%':'100%', display: "flex", "flex-direction": "column"}}>
                          <img src={turingImgSrc} style={{ width: "100%"}} />  
                          <Turning turningCountData={turningCountData} positions={{left:285, top:240}}/>
                            <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute" }}>
                              <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(270deg)" }}>
                                <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                                  <span>{approaches.eb_approach}</span>
                                </div>
                              </div>
                              <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(90deg)" }}>
                                <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                                  <span>{approaches.wb_approach}</span>
                                </div>
                              </div>
                            </div>
                        </div>
                          <div className='nb-approach' style={{ margin: "-15px 0px 10px 0px" }}>
                            <span>{approaches.nb_approach}</span>
                          </div>
                      </div>
                    </Card>
                  </div>
                  <div className='details-tf-study-card'>
                    <label>Truck percentages</label>
                    <Card className='details-main-info-img'>
                      <div className='intersection-counts-pn' style={{textAlign:'center'}}>
                      {(showLoader)?<div className='loader-details-progress top-280'>
                        <div className={'loader'}></div>
                      </div>:null } 
                          <div className='sb-approach' style={{ margin: "15px 0px -10px 0px" }}>
                            <span>{approaches.sb_approach}</span>
                          </div>
                        <div style={{width:'608px',height:'608px',position:'relative',left:'50%',marginLeft:'-304px',opacity: showLoader?'50%':'100%', display: "flex", "flex-direction": "column"}}>
                          <img src={trackImage} style={{ width: "100%"}} />  
                          <Trunk truckCountData={truckCountData}/>
                          <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute" }}>
                              <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(270deg)" }}>
                                <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                                  <span>{approaches.eb_approach}</span>
                                </div>
                              </div>
                              <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(90deg)" }}>
                                <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                                  <span>{approaches.wb_approach}</span>
                                </div>
                              </div>
                            </div>
                        </div>
                          <div className='nb-approach' style={{ margin: "-15px 0px 10px 0px" }}>
                            <span>{approaches.nb_approach}</span>
                          </div>
                      </div>
                    </Card>
                  </div>
                </div>
                <div className='details-tf-study'>
                  <div className='details-tf-study-card' style={{marginRight:'16px'}}>
                    <label>Pedestrian volumes</label>
                    <Card className='details-main-info-img'>
                      <div className='intersection-counts-pn' style={{textAlign:'center'}}>
                      {(showLoader)?<div className='loader-details-progress top-280'>
                        <div className={'loader'}></div>
                      </div>:null } 
                          <div className='sb-approach' style={{ margin: "15px 0px -10px 0px" }}>
                            <span>{approaches.sb_approach}</span>
                          </div>
                        <div style={{width:'608px',height:'608px',position:'relative',left:'50%',marginLeft:'-304px',opacity: showLoader?'50%':'100%', display: "flex", "flex-direction": "column"}}>
                          <img src={pedestrianImage} style={{ width: "100%"}} />  
                          <Pedestrian pedestrianData={pedestrianData}/>
                            <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute" }}>
                              <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(270deg)" }}>
                                <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                                  <span>{approaches.eb_approach}</span>
                                </div>
                              </div>
                              <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(90deg)" }}>
                                <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                                  <span>{approaches.wb_approach}</span>
                                </div>
                              </div>
                            </div>
                        </div>
                          <div className='nb-approach' style={{ margin: "-15px 0px 10px 0px" }}>
                            <span>{approaches.nb_approach}</span>
                          </div>
                      </div>
                    </Card>
                  </div>
                  <div className='details-tf-study-card'>
                    <label>Bicycle movements</label>
                    <Card className='details-main-info-img'>
                      <div className='intersection-counts-pn' style={{textAlign:'center'}}>
                      {(showLoader)?<div className='loader-details-progress top-280' >
                        <div className={'loader'}></div>
                      </div>:null } 
                          <div className='sb-approach' style={{ margin: "15px 0px -10px 0px" }}>
                            <span>{approaches.sb_approach}</span>
                          </div>
                        <div style={{width:'608px',height:'608px',position:'relative',left:'50%',marginLeft:'-304px',opacity: showLoader?'50%':'100%', display: "flex", "flex-direction": "column"}}>
                          <img src={bicycleImage} style={{ width: "100%"}} /> 
                          <img src={pedestrianImage} style={{ width: "100%"}} /> 
                          <Cycle bicycleCountData={bicycleCountData} bicycleCrosswalkCountData={bicycleCrosswalkCountData} />
                            <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute" }}>
                              <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(270deg)" }}>
                                <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                                  <span>{approaches.eb_approach}</span>
                                </div>
                              </div>
                              <div style={{ display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform: "rotate(90deg)" }}>
                                <div style={{ width: "100%", position: "absolute", top: "-8px" }}>
                                  <span>{approaches.wb_approach}</span>
                                </div>
                              </div>
                            </div>
                        </div>
                        <div className='nb-approach' style={{ margin: "-15px 0px 10px 0px" }}>
                            <span>{approaches.nb_approach}</span>
                          </div>
                      </div>
                    </Card>
                  </div>
                </div>          
                <div className='details-tf-chart'>
                  <label>Traffic counts by approach</label>
                  {(showLoader)?<div className='loader-details-progress '>
                        <div className={'loader'}></div>
                      </div>:null } 
                  <Card style={{opacity: showLoader?'50%':'100%'}}>                      
                    {myOptions && JSON.stringify(getResponseData) != "{}" ? <ReactEcharts option={myOptions} style={{ height: '560px' }} /> :
                      <div style={{padding:'10px'}}><NoDetails/></div>}
                  </Card>
                </div>    
                <div className='details-tf-table'>
                  <label>Data displayed for all vehicles</label>
                  <DataVehicles 
                    getResponseApproches={getResponseApproches}
                    getResponseData={getResponseData}
                    startPeakHour={startPeakHour}
                    endPeakHour={endPeakHour}
                    startPeakMin={startPeakMin}
                    endPeakMin={endPeakMin}
                    getDashedArray={getDashedArray}
                  />
                </div>
              </TabPanel>  
              <TabPanel value={tabValue} index={2} dir={theme.direction}>  
                <SignalPlanning 
                  hasData={props.hasData} 
                  sharedStation={props.sharedStation}
                  sharedAgencyName={props.sharedAgencyName}
                  stationData={props.stationData}
                  turningCountDate={turningCountDate} 
                  pedestrianCountDate={pedestrianCountDate} 
                  biCycleCountDate={biCycleCountDate}
                  setShowNewScenario={setShowNewScenario}
                  reloadScenarios={reloadScenarios}
                  setReloadScenarios={setReloadScenarios}
                  peakData={peakData}
                  setShowDeleteScenario={setShowDeleteScenario}
                  newScenarioId={newScenarioId}
                  setNewScenarioId={setNewScenarioId}
                  setScenarioToDelete={setScenarioToDelete}
                  setShowLaneConfig={setShowLaneConfig}
                  setReadOnlyOpt={setReadOnlyOpt}
                  activeFromCard={activeFromCard}
                />
              </TabPanel> 
              </SwipeableViews>           
             </div>
           </div>  
          </Modal> 
          
          {
            showNewScenario &&
            <CreateScenario 
              setShowNewScenario={setShowNewScenario} 
              showNewScenario={showNewScenario} 
              setReloadScenarios={setReloadScenarios}
              stationData={props.stationData}
              setNewScenarioId={setNewScenarioId}
              peakData={peakData}
            />
          }
          {
            showDeleteScenario &&
            <DeleteScenario 
              showDeleteScenario={showDeleteScenario}
              setShowDeleteScenario={setShowDeleteScenario}
              scenarioToDelete={scenarioToDelete}
              handleDeleteScenario={handleDeleteScenario}
            />
          }
          {
            showLaneConfig &&
            <LaneGeometry 
              showLaneConfig={showLaneConfig}
              setShowLaneConfig={setShowLaneConfig}
              readOnly={readOnlyOpt}
              lat={props.stationData.latitude}
              long={props.stationData.longitude}
              stationType={props.stationData.station_type}
              laneConfigId={props.stationData.FK_lane_config_id}
              approachesForLane={[{eb_approach:props.stationData.eb_approach}, {nb_approach:props.stationData.nb_approach}, {sb_approach:props.stationData.sb_approach}, {wb_approach:props.stationData.wb_approach}]}
              stationId={props.stationData.station_id}
            />
          }
        </React.Fragment>
    );

}

export default Intersection;
//End Intersection component code ...